<template>
  <multiselect
    v-model="selected"
    class="select-lang-container mt-1 mr-1"
    :options="options"
    :multiple="false"
    :showLabels="false"
    :allowEmpty="false"
    :searchable="false"
    @select="onSelect"
  >
    <div v-if="props && props.option" slot="singleLabel" slot-scope="props">
      <country-flag :country="props.option.flag" />
      <span class="lang-name"> {{ props.option.title }} </span>
    </div>
    <div v-if="props && props.option" slot="option" slot-scope="props">
      <country-flag :country="props.option.flag" />
      <span class="lang-name"> {{ props.option.title }} </span>
    </div>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import CountryFlag from "vue-country-flag";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { EventBus } from "@/event-bus";

export default {
  components: {
    Multiselect,
    CountryFlag,
  },
  props: {
    initLang: {
      type: Object,
      default() {
        return {
          title: "ru",
          flag: "ru",
        };
      },
    },
    options: {
      type: Array,
      default() {
        return [
          {
            title: "en",
            flag: "gb",
          },
        ];
      },
    },
  },
  created() {
    this.selected =
      this.options.filter((f) => f.loc === (localStorage.lang || "Ru"))[0] ||
      this.initLang;
  },
  methods: {
    onSelect(lang) {
      localStorage.lang = lang.loc;
      this.$i18n.locale = lang.loc.toLowerCase();
      this.$validator.localize(this.$i18n.locale);
      EventBus.$emit("lang-changed", this.$i18n.locale);
      this.$emit("changed", lang);
    },
  },
  data() {
    return {
      selected: null,
    };
  },
};
</script>

<style scoped>
.multi-select-language {
  color: #e8e8e8;
  width: 80px;
  height: 40px !important;
}
.multiselect__select {
  border: 1px solid #e8e8e8;
  background: #fff;
  color: #e8e8e8;
  height: 40px;
}

.multiselect__tags {
  height: 40px !important;
  min-height: 30px !important;
  padding: 0;
}

.multi-select-language img {
  height: 25px;
  width: 25px;
  background-color: transparent;
}

.multi-select-language .option__title {
  color: #e8e8e8;
  background-color: transparent;
}

.multiselect__single {
  width: 28px;
  height: 28px;
  margin: 0 !important;
}

.multiselect__option--selected {
  background-color: grey;
}

.multiselect__option--highlight {
  background-color: royalblue;
  background: royalblue;
}
.select-lang-container {
  width: 200px;
}
.flag {
  margin-top: -10px !important;
  margin-bottom: -14px !important;
}
</style>
